"use client";
import { GlobalContext } from "@/context";
import axios from "axios";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useContext, useEffect, useRef, useState } from "react";

export default function Home() {
  const router = useRouter();

  const { userData, setUserData, connected, setConnected } =useContext(GlobalContext);
 
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();

  const emailRef = useRef();
  const passwordRef = useRef();

  useEffect(() => {
    if (connected) {
      router.push("/dashboard");
    }
  }, [connected]);
  const signIn = () => {
    // Validate inputs
    if (!email || !password) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    axios
      .post(
        `${process.env.NEXT_PUBLIC_URL}/auth/admin/signin`,
        {
          email: email.trim(),
          password: password.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true, // Important: This sends the cookies along with the request
        }
      )
      .then((res) => {
        setError(null);
        localStorage.setItem("connected", true);
        localStorage.setItem(
          "admin",
          JSON.stringify({
            name: res.data.data.user.name,
            phoneNumber: res.data.data.user.phoneNumber,
            email: res.data.data.user.email,
            id: res.data.data.user._id,
          })
        );
        setUserData({
          name: res.data.data.user.name,
          phoneNumber: res.data.data.user.phoneNumber,
          email: res.data.data.user.email,
          id: res.data.data.user._id,
        });
        setConnected(true);
        router.push("/dashboard");
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.msg || err.message || 'Erreur de connexion. Veuillez réessayer.';
        setError(errorMessage);
        console.error('Login error:', err);
      });
  };

  return (
    <div className="bg-[url('/loginBg.png')] bg-cover w-[100vw] h-[100vh] flex flex-col justify-center items-center text-center">
      <Image
        src="/logo.png"
        width={1000}
        height={1000}
        alt="MISTER BOUTON LOGO"
        className="w-[278px] h-[106px] mx-auto"
      />
      <h1 className="text-[52px] font-black text-[#CC0001] uppercase mt-12">
        cliquez ici pour vous connecter{" "}
      </h1>
      <h3 className="text-[23px] text-[#4A4A4A] font-medium mb-14">
        Vous avez déjà un compte ?
      </h3>

      <h2 className="text-[40px] font-agency font-bold text-[#000000] mb-6">
        Se connecter
      </h2>
      {/* Form Login */}
      <div className="flex flex-col gap-6 ">
        <div
          className={`w-[260px] relative h-[28px]  drop-shadow-2xl  rounded-[16px] border-[#FFFFFF] border-[1px] mx-auto`}
        >
          <div
            className={`w-[255px] pointer-events-none absolute top-0 left-[2px] right-[2px] h-3  bg-gradient-to-b from-gray-300 to-transparent rounded-t-[16px]`}
          ></div>
          <input
            type="email"
            placeholder="Adresse E-mail"
            className={`w-[260px] h-[33px] overflow-hidden placeholder:text-start placeholder:text-[#4A4A4A] placeholder:text-[13px] md:placeholder:text-[15px] px-6 rounded-[16px]`}
            value={email || ''}
            ref={emailRef}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div
          className={`w-[260px] relative h-[28px]  drop-shadow-2xl  rounded-[16px] border-[#FFFFFF] border-[1px] mx-auto`}
        >
          <div
            className={`w-[255px] pointer-events-none absolute top-0 left-[2px] right-[2px] h-3  bg-gradient-to-b from-gray-300 to-transparent rounded-t-[16px]`}
          ></div>
          <input
            type="password"
            placeholder="Mot de passe"
            className={`w-[260px] h-[33px] overflow-hidden placeholder:text-start placeholder:text-[#4A4A4A] placeholder:text-[13px] md:placeholder:text-[15px] px-6 rounded-[16px]`}
            value={password || ''}
            ref={passwordRef}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <h2 className="text-[#CC0001] font-semibold underline">{error}</h2>
      </div>

      {/*Forget Passwork*/}
       {/* <h3 className="text-[15px] text-[#4A4A4A] font-medium underline mt-9">
        mot de passe oublié?
      </h3>  */}

      <button
        onClick={signIn}
        className="bg-[#CC0001] px-4 text-[#FFFFFF] font-medium rounded-[13px] mt-9"
      >
        Se connecter
      </button>
    </div>
  );
}
